export function getSubjectMentionOffsets(text, subjectName) {
  if (!text || !subjectName) return [];

  const offsets = [];
  let searchStart = 0;

  while (searchStart < text.length) {
    const offset = text.indexOf(subjectName, searchStart);
    if (offset === -1) break;
    offsets.push(offset);
    searchStart = offset + subjectName.length;
  }

  return offsets;
}

export function getNextMentionSelection(text, subjectName, currentCycleIndex = 0) {
  const offsets = getSubjectMentionOffsets(text, subjectName);
  if (!offsets.length) {
    return null;
  }

  const normalizedIndex = currentCycleIndex % offsets.length;
  return {
    offset: offsets[normalizedIndex],
    nextCycleIndex: (normalizedIndex + 1) % offsets.length,
    total: offsets.length,
  };
}
